module.exports = __webpack_public_path__ + "joy-static/media/FrostBorderBottom.409d789d.png";